"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SpecificitiesFieldFilter = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@material-ui/core");
var _reactRedux = require("react-redux");
var _AddFilterButton = require("./AddFilterButton");
var _tableHooks = require("../../../tableHooks");
var _MultiSelectField = require("./MultiSelectField");
var _styles = require("@material-ui/core/styles");
var _TableFilters = require("../TableFilters");
var _OptionsFilter = require("./OptionsFilter");
var _excluded = ["allFilters", "setAllFilters"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var useStyle = (0, _styles.makeStyles)(function (theme) {
  return {
    selectField: {
      width: "100%",
      marginTop: "0.5rem"
    },
    selectFieldDisplay: {
      maxWidth: "250px",
      whiteSpace: "pre-wrap"
    },
    circularProgressWrapper: {
      display: "grid",
      placeItems: "center",
      marginTop: "0.5rem"
    },
    wrapper: {
      marginTop: "0.5rem"
    },
    addButtonWrapper: {
      display: "grid",
      placeItems: "center"
    },
    menuList: {
      position: "relative",
      maxHeight: "calc(100vh - 200px)"
    },
    container: {
      position: "sticky",
      bottom: "0px"
    },
    bottomButtonsWrapper: {
      background: theme.palette.common.white,
      padding: "1rem"
    }
  };
});
var SpecificitiesFieldFilter = /*#__PURE__*/_react.default.forwardRef(function (_ref, handleAddFilterRef) {
  var allFilters = _ref.allFilters,
    setAllFilters = _ref.setAllFilters,
    props = _objectWithoutProperties(_ref, _excluded);
  var classes = useStyle();
  // this state is used to store the filter operator options (is, is not, is null, is not null, etc)
  var _useFilterOptions = (0, _tableHooks.useFilterOptions)("string"),
    filterOption = _useFilterOptions.filterOption,
    setFilterOption = _useFilterOptions.setFilterOption;
  var _useState = (0, _react.useState)(""),
    _useState2 = _slicedToArray(_useState, 2),
    term = _useState2[0],
    setTerm = _useState2[1];
  // this state is used to store the value of the selected specificity that we want to filter by
  var _useSelector = (0, _reactRedux.useSelector)(function (state) {
      return {
        specificities: state.specificityOfProductReducer.specificities,
        fetchSpecificitiesInProgress: state.specificityOfProductReducer.fetchSpecificitiesInProgress
      };
    }),
    specificities = _useSelector.specificities,
    fetchSpecificitiesInProgress = _useSelector.fetchSpecificitiesInProgress;
  var _useState3 = (0, _react.useState)(specificities[0] || {}),
    _useState4 = _slicedToArray(_useState3, 2),
    specificity = _useState4[0],
    setSpecificity = _useState4[1];
  // this state is used to store the values of the selected choices when the specificity is a list
  var _useState5 = (0, _react.useState)([]),
    _useState6 = _slicedToArray(_useState5, 2),
    values = _useState6[0],
    setValues = _useState6[1];
  var selectedSpecificityType = specificity.type === "free" ? "string" : specificity.type;
  var isFilterOptionNull = ["3", "4"].includes(filterOption.id);
  var handleTerm = (0, _react.useCallback)(function (event) {
    setTerm(event.target.value);
  }, []);
  var handleSpecificityFilter = (0, _react.useCallback)(function (event) {
    var specificity = specificities.find(function (specificity) {
      return specificity.id === event.target.value;
    });
    setSpecificity(specificity);
    setTerm("");
    setValues([]);
  }, [specificities, setValues]);
  var handleAddFilter = function handleAddFilter() {
    var formatMessage = props.intl.formatMessage;
    var filterLabel = "";
    if (values.length) {
      var specificityValuesLabels = specificity.choices.filter(function (_ref2) {
        var value = _ref2.value;
        return values.includes(value);
      }).map(function (_ref3) {
        var label = _ref3.label;
        return label;
      }).join(", ");
      filterLabel = "".concat(specificity.name, " ").concat(formatMessage({
        id: filterOption.label,
        defaultMessage: filterOption.label
      }), " ").concat(specificityValuesLabels);
    } else {
      filterLabel = "".concat(specificity.name, " ").concat(formatMessage({
        id: filterOption.label,
        defaultMessage: filterOption.label
      }), " ").concat(term);
    }
    var specType = specificity.type === "m_list" ? "choices" : specificity.type === "date" ? "date" : "choice";
    var filterName = "".concat(filterOption.symbol, "product_specificities.").concat(specType, "_").concat(specificity.id);
    var filterValue = term ? filterOption.label === "contient" ? "%".concat(term, "%") : term : values.length ? values : "null";
    var columnName = specificity.name;
    if (term || values.length) {
      setTerm("");
      setValues([]);
      return (0, _TableFilters.setFilter)({
        allFilters: allFilters,
        setAllFilters: setAllFilters,
        columnName: columnName,
        filterLabel: filterLabel,
        filterName: filterName,
        filterValue: filterValue
      });
    }
    return allFilters;
  };
  handleAddFilterRef.current = handleAddFilter;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, fetchSpecificitiesInProgress ? /*#__PURE__*/_react.default.createElement("div", {
    className: classes.circularProgressWrapper
  }, /*#__PURE__*/_react.default.createElement(_core.CircularProgress, null)) : /*#__PURE__*/_react.default.createElement(_core.Select, {
    className: classes.selectField,
    variant: "outlined",
    value: specificity.id,
    onChange: handleSpecificityFilter
  }, specificities.map(function (_ref4) {
    var name = _ref4.name,
      id = _ref4.id;
    return /*#__PURE__*/_react.default.createElement(_core.MenuItem, {
      key: id,
      value: id
    }, name);
  })), !fetchSpecificitiesInProgress && /*#__PURE__*/_react.default.createElement(_OptionsFilter.OptionsFilter, _extends({
    filterType: selectedSpecificityType,
    filterOption: filterOption,
    setFilterOption: setFilterOption,
    setTerm: setTerm,
    classes: classes
  }, props)), specificity.type === "list" ? /*#__PURE__*/_react.default.createElement(_MultiSelectField.MultiSelectField, {
    valuesToRender: specificity.choices || [],
    classes: classes,
    setValues: setValues,
    values: values
  }) : /*#__PURE__*/_react.default.createElement(_core.TextField, {
    className: classes.selectField,
    type: specificity.type === "free" ? "text" : specificity.type,
    value: term,
    onChange: handleTerm,
    id: "outlined-basic",
    variant: "outlined"
  }), allFilters.length < 5 && /*#__PURE__*/_react.default.createElement(_AddFilterButton.AddFilterButton, {
    isDisabled: !isFilterOptionNull && !term && !values.length,
    handleClick: handleAddFilter
  }));
});
exports.SpecificitiesFieldFilter = SpecificitiesFieldFilter;